/**
 * Maps a Canvas model key to its Vercel AI Gateway model id.
 *
 * The gateway uses a Virtual Model Catalog (VMC) namespace
 * (vmc/zapier-ai-provider-*) and drops the date snapshot carried by the legacy
 * zapier-multi-provider-* ids. Models with no configured VMC fall back to a
 * fully-qualified <provider>/<model> id (a bare model name is never valid).
 *
 * Ids come from the AI Gateway "configured VMCs" catalog. Keep this map in sync
 * whenever Canvas adds or changes a supported model. Shared by the service
 * (request path) and copilot-tools (sync embedding/batch jobs) proxy configs so
 * the two can't drift.
 */
export const VERCEL_AI_GATEWAY_MODEL_IDS: Readonly<Record<string, string>> = {
  "zapier-multi-provider-gpt-4.1-2025-04-14": "vmc/zapier-ai-provider-gpt-4.1",
  "zapier-multi-provider-gpt-4.1-mini-2025-04-14":
    "vmc/zapier-ai-provider-gpt-4.1-mini",
  // No VMC for claude-sonnet-4 — fall back to the provider-qualified id.
  "zapier-multi-provider-claude-sonnet-4-20250514": "anthropic/claude-sonnet-4",
  "zapier-multi-provider-claude-sonnet-4-5-20250929":
    "vmc/zapier-ai-provider-claude-sonnet-4-5",
  "zapier-multi-provider-text-embedding-3-large":
    "vmc/zapier-ai-provider-text-embedding-3-large",
};
